// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__fGGsS","consentsList":"PatientConsents_consentsList__3icPi","consentsListEmpty":"PatientConsents_consentsListEmpty__3f_w6"};